import partners from './components/partnership';
import breeders from './components/dogBreeders';
import titles from './components/dogTitles';
import browser from './components/browserChecker';
import initDatePicker from './components/datePicker';
import toggleShowClass from './components/toggleShowClasses';
import exportLogout from './components/logout';

function main() {
    partners();
    breeders();
    titles();
    browser();
    initDatePicker();
    toggleShowClass();
    exportLogout();

    require('./components/editClasses');
}

if (document.readyState === 'interactive') {
    main();
} else {
    document.onreadystatechange = () => {
        if (document.readyState === 'interactive') {
            main();
        }
    };
}



// WEBPACK FOOTER //
// ./resources/js/frontend/app.js